import http from "../axios/http-common";

class InterfaceCatatanEdukasi {
  getCatatanEdukasi(reg) {
    return http.getData(`/catatatan-edukasi-pasien/register/${reg}`);
  }
  
  saveCatatanEdukasi(
    reg, rm, param
  ) {
    return http.postData(`/catatatan-edukasi-pasien`, {
      register_id: reg,
      pasien_rm: rm,
      kebutuhan_edukasi:param["kebutuhan_edukasi"],
      edukasi_kolaborasi:param["edukasi_kolaborasi"],
      pelaksanaan_edukasi:param["pelaksanaan_edukasi"]
    });
  }
  editCatatanEdukasi(
      id, reg, rm, param
    ) {
      return http.putData(`/catatatan-edukasi-pasien/${id}`, {
        register_id: reg,
        pasien_rm: rm,
        kebutuhan_edukasi:param["kebutuhan_edukasi"],
        edukasi_kolaborasi:param["edukasi_kolaborasi"],
        pelaksanaan_edukasi:param["pelaksanaan_edukasi"]
      });
    }
}
export default new InterfaceCatatanEdukasi();
